import { Transfer, Button } from 'antd';

import React, { Component } from 'react';

export default class App extends Component {
	state = {
		mockData: [],
		targetKeys: [],
	};

	componentDidMount() {
		this.props.querySearch().then(res => {

			const mockData = [];
			res.forEach(d => {
				const data = {
					key: d.value.toString() + d.type,
					value: d.value,
					title: d.label,
					description: d.description,
					type: d.type,
				};
				mockData.push(data)
			});
			this.setState({ mockData });

			if (this.props.defaultValue) {
				this.setState({ 
					targetKeys: this.props.defaultValue
				 });
			}
			

		})
	}


	handleChange = targetKeys => {
		const targetData = []

		this.state.mockData.forEach(data => {
			if (targetKeys.includes(data.key)) {
				targetData.push(data)
			}
		})
		this.setState({ targetKeys });

		if (this.props.handleChange) {
			this.props.handleChange(targetData);
		}
	};


	render() {

		const {style, label, operations,className, actionDisable, getFieldDecorator} = this.props;
		return (
			<div className= {className || 'ky-transfer'}>
			<Transfer
				dataSource={this.state.mockData}
				titles={label || ['可选项目', '已选项目']}
				showSearch
				listStyle={style || {
					width: 450,
					height: 450,
				}}
				operations={operations || ['添加所选', '删除所选']}
				targetKeys={this.state.targetKeys}
				onChange={this.handleChange}
				render={item => `${item.description}`}
			/>
			</div>
		);
	}
}
